import { useContext } from "react";
import { type PaginationInterpreter, usePaginationService } from "../../common/state";
import { LenssourceModelLensSourceType as LensSourceType } from "../../../gql-generated/types";
import { LensSourcesPaginationContext } from "../context/LensSourcesPaginationContext";

export function useLensSourcePaginationContext(type: LensSourceType) {
    const paginationServices = useContext(LensSourcesPaginationContext);

    if (!paginationServices) {
        throw new Error("useLensSourcePaginationContext must be used within LensSourcesPaginationProvider");
    }

    return usePaginationService(paginationServices.get(type) as PaginationInterpreter);
}
